import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const RolloutIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "73px", height: props.height ?? "72px" }}
    >
      <svg
        {...props}
        viewBox="0 0 73 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1593_23463"
          // style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="73"
          height="72"
        >
          <rect x="0.5" width="72" height="72" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1593_23463)">
          <path
            d="M21.4639 58.4664C20.0526 58.4664 18.8674 57.9812 17.9084 57.011C16.9495 56.0407 16.47 54.8416 16.47 53.4137C16.47 52.0224 16.9495 50.8416 17.9084 49.8714C18.8674 48.9011 20.0526 48.416 21.4639 48.416C22.5134 48.416 23.4452 48.6998 24.2594 49.2673C25.0737 49.8348 25.6798 50.5945 26.0779 51.5465C28.8644 49.9721 31.1352 47.8394 32.8903 45.1483C34.6454 42.4572 35.7582 39.519 36.2286 36.3336H26.4579C26.2407 37.6151 25.6527 38.6769 24.6937 39.519C23.7347 40.3611 22.6581 40.7821 21.4639 40.7821C20.0526 40.7821 18.8674 40.297 17.9084 39.3268C16.9495 38.3565 16.47 37.1574 16.47 35.7295C16.47 34.3016 16.9495 33.1025 17.9084 32.1323C18.8674 31.162 20.0526 30.6769 21.4639 30.6769C22.6581 30.6769 23.7347 31.0979 24.6937 31.94C25.6527 32.7821 26.2407 33.8439 26.4579 35.1254H36.2286C35.7582 31.94 34.6454 29.011 32.8903 26.3382C31.1352 23.6654 28.8644 21.5236 26.0779 19.9126C25.6798 20.9011 25.0737 21.67 24.2594 22.2192C23.4452 22.7684 22.5134 23.043 21.4639 23.043C20.0526 23.043 18.8674 22.5579 17.9084 21.5876C16.9495 20.6174 16.47 19.4366 16.47 18.0453C16.47 16.6174 16.9495 15.4183 17.9084 14.4481C18.8674 13.4778 20.0526 12.9927 21.4639 12.9927C22.9476 12.9927 24.1961 13.5785 25.2094 14.7501C26.2226 15.9217 26.6207 17.2947 26.4036 18.8691C29.5158 20.4069 32.0308 22.6311 33.9488 25.5419C35.8668 28.4526 37.0248 31.6471 37.4228 35.1254H54.196L48.9849 29.8531L49.8534 28.9744L56.5301 35.7295L49.8534 42.4847L48.9849 41.6059L54.196 36.3336H37.4228C37.0248 39.8485 35.8577 43.043 33.9216 45.9172C31.9856 48.7913 29.4796 51.0156 26.4036 52.5899C26.6207 54.1643 26.2226 55.5373 25.2094 56.7089C24.1961 57.8805 22.9476 58.4664 21.4639 58.4664Z"
            fill="#7BBC7B"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
